<script setup>
/**
 * Page content area that fills the remaining space inside an HrLayout.
 *
 * @status recommended
 * @group layout
 * @useWhen Wrapping page content inside an HrLayout/HrPageContainer hierarchy
 * @within hr-layout hr-page-container
 * @see https://quasar.dev/layout/page Quasar q-page API
 */
defineOptions({ name: 'HrPage' });
</script>

<template>
  <q-page v-bind="$attrs">
    <!-- @slot Page content. -->
    <slot />
  </q-page>
</template>

<style scoped>
.q-page {
  --hr-page-padding: var(--app-comp-page-padding-md);
  padding: var(--hr-page-padding);
}

@media (max-width: 599px) {
  .q-page {
    --hr-page-padding: var(--app-comp-page-padding-sm);
  }
}
</style>
